import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import InfoBar from '../components/Navigation/InfoBar';
import EstablishmentModal from '../components/Modal/EstablishmentModal';
import * as ROUTES from '../constants/routes';
import DeleteEstablishmentModal from '../components/Modal/DeleteEstablishmentModal';
import { useUser } from '../hooks/use-user';
import EstablishmentOverview from '../components/Tables/Establishments/EstablishmentOverview';

function EstablishmentListPage() {
	const { activeCompany, refetchProfile } = useUser();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const establishments = activeCompany?.establishments || [];
	const [selectedEstablishment, setSelectedEstablishment] = useState([]);
	const [showEditModal, setEditModal] = useState(false);
	const [showDeleteModal, setDeleteModal] = useState(false);

	return (
		<>
			<InfoBar
				backTitle={t('establishments.establishments')}
				goBack={() => navigate(ROUTES.SETTINGS)}
			/>
			<>
				<div className="d-flex flex-row-reverse mx-5">
					<Button
						variant="outline-secondary"
						className="rounded-button p-1"
						type="button"
						onClick={() => {
							setSelectedEstablishment(null);
							setEditModal(true);
						}}>
						<span className="glyphicons glyphicons-plus" />
					</Button>
				</div>
				<>
					<EstablishmentModal
						show={showEditModal}
						setShow={() => {
							setEditModal(false);
						}}
						selectedEstablishment={selectedEstablishment}
						handleSubmit={refetchProfile}
					/>
					<DeleteEstablishmentModal
						show={showDeleteModal}
						setShow={(show) => {
							setSelectedEstablishment({});
							setDeleteModal(show);
						}}
						establishmentId={selectedEstablishment?.id}
						title={t('establishments.delete')}
						message={t('establishments.confirm_delete', { name: selectedEstablishment?.name })}
						successMessage={t('establishments.deleted', { name: selectedEstablishment?.name })}
						handleSubmit={refetchProfile}
					/>
					<div className="col-12 col-xl-10 mx-auto pt-n5">
						<EstablishmentOverview
							establishments={establishments || []}
							handleDelete={(data) => {
								setSelectedEstablishment(data);
								setDeleteModal(true);
							}}
							handleRowClick={(data) => {
								setSelectedEstablishment(data);
								setEditModal(true);
							}}
						/>
					</div>
				</>
			</>
		</>
	);
}

export default EstablishmentListPage;
